import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-point-of-sale-terms-of-service-article',
  standalone: true,
  imports: [
    PolicyArticleComponent, ArticleTitleDirective, ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Point-of-sale terms of service</span>
      <div articleBody class="body-1-regular-1">
        <section>
          <div class="heading">Requesting a Point of Sale Account</div>

          <section>
            <div class="heading">Process Overview:</div>
            <ul>
              <li>
                Landlords must use their dedicated Landlord Portal to request a POS account on behalf of retailers
                associated with a specific lease.
              </li>
              <li>
                Upon receiving a request, Nter Platform will set up the linked POS account using a third-party POS
                system and coordinate the issuance of necessary hardware, such as card machines, to the retailer.
              </li>
            </ul>
          </section>

          <section>
            <div class="heading">Responsibilities:</div>
            <div>
              By requesting a POS account, landlords agree to be fully responsible for ensuring the completion of all
              required data and information and will manage the activities related to the POS account until it is handed
              over to the retailer .
            </div>
          </section>

          <section>
            <div class="heading">Timeline and Lead Times:</div>
            <ul>
              <li>
                A minimum of <b>three business days</b> is required between the POS request date and the POS activation
                date to
                ensure proper setup and integration.
              </li>

              <li>
                The POS activation date must be scheduled to accommodate the lease start date, and cannot be set for a
                past date.
              </li>
            </ul>
          </section>

          <section>
            <div class="heading">Billing:</div>
            <ul>
              <li>
                Billing commences on the POS activation date, or no more than three business days prior to the
                activation date.
              </li>
              <li>
                Fees are billed monthly based on the POS billing date.
              </li>
            </ul>
          </section>

          <section>
            <div class="heading">Examples of Lead and Turnaround Times:</div>
            <ul>
              <li>
                <b>POS Request Date:</b> 29 January
              </li>
              <li>
                <b>Billing Period:</b> Between 29 January and 31 January
              </li>
              <li>
                <b>POS Activation Date/Lease Start:</b> 1 February
              </li>
            </ul>
          </section>
        </section>

        <section>
          <div class="heading">Cancelling a Point of Sale Account</div>
          <section>
            <div class="heading">Process Overview:</div>
            <div>
              Landlords must request the cancellation of a POS account via the Landlord Portal, providing all required
              data or information in a complete and timely manner.
            </div>
          </section>

          <section>
            <div class="heading">Responsibilities:</div>
            <div>
              By cancelling a POS, landlords agree to be fully responsible for all activities that occur relating to
              this service, including access, usability, and any owed fees until the POS account is fully deactivated.
            </div>
          </section>

          <section>
            <div class="heading">Timeline and Lead Times:</div>
            <ul>
              <li>
                No lead time is required between the POS cancellation request date and the POS deactivation date.
              </li>
              <li>
                The POS account will be terminated within <b>seven to ten calendar days</b> following the POS
                deactivation request date.
              </li>
              <li>
                The POS cancellation request date cannot be set for a past date.
              </li>
            </ul>
          </section>

          <section>
            <div class="heading">Billing:</div>
            <ul>
              <li>
                Billing ends on the same month that the POS is deactivated if the POS billing date falls outside of the
                cancellation period.
              </li>
              <li>
                Billing ends on the month following deactivation if the POS billing date falls within the cancellation
                period.
              </li>
            </ul>
          </section>

          <section>
            <div class="heading">Examples of Lead and Turnaround Times:</div>
            <ul>
              <li>
                <b>POS Cancellation Request Date:</b> 30 March
              </li>
              <li>
                <b>Deactivation/Lease End Date:</b> 31 March
              </li>
              <li>
                <b>POS Termination Date:</b> 10 April
              </li>
            </ul>
          </section>

        </section>
      </div>
    </app-policy-article>
  `
})
export class PointOfSaleTermsOfServiceArticleComponent {

}
